import { render, staticRenderFns } from "./add-tenant-modal.vue?vue&type=template&id=539ad686&"
import script from "./add-tenant-modal.vue?vue&type=script&lang=tsx&"
export * from "./add-tenant-modal.vue?vue&type=script&lang=tsx&"
import style0 from "./add-tenant-modal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports